module.exports = __webpack_public_path__ + "img/teaching-1.2fb4135a.png";